import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsMS: CultureInfo = {
  name: 'es-MS',
  displayName: 'español (Montserrat)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-MS',
  parent: CultureInfoEs
};
